module.exports = __webpack_public_path__ + "static/media/vn.acbd7b77.svg";